"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _bowser = _interopRequireDefault(require("bowser"));
var _enums = require("./enums");
var _x = _interopRequireDefault(require("@ux/icon/x"));
var _alert = _interopRequireDefault(require("@ux/icon/alert"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * A Banner to be displayed if your browser is too old.
 * @type {BrowserDeprecationBanner}
 */
class BrowserDeprecationBanner extends _react.Component {
  constructor() {
    super(...arguments);
    this.dismiss = this.dismiss.bind(this);
    let name, version, mac;
    if (typeof navigator !== 'object' || !navigator.userAgent) {
      // pretend to be something we support on server side
      // so we don't briefly flash the banner on supported Browsers
      name = 'Chrome';
      version = '99999999999';
      mac = false;
    } else {
      const parsed = _bowser.default.parse(navigator.userAgent);
      this.userAgent = parsed;
      name = parsed.browser.name;

      // Some browser names differ in the more recent versions of `bowser`, but we don't want to go update config and
      // other code too much. So we normalize here.
      if (name in _enums.browserNormalizations) name = _enums.browserNormalizations[name];
      version = parsed.browser.version;
      mac = !!parsed.os.name && (!!~parsed.os.name.toLowerCase().indexOf('mac') || !!~parsed.os.name.toLowerCase().indexOf('ios'));
    }
    this.state = {
      mac: !!mac,
      name,
      version,
      dismissed: false
    };
  }

  /**
   * Handle a user clicking the X to permanently dismiss this
   * banner. The "permanence" lasts for the session.
   * @private
   */
  dismiss() {
    this.trySetSessionStorage('_dismissedBDF', 'true');
    this.setState({
      dismissed: true
    });
    typeof document !== 'undefined' && document.documentElement.classList.remove('browser-deprecation-banner-shown');
  }

  /**
   * Try to set a session storage item
   *
   * @param {string} key Key of item to set
   * @param {string} value Value of item to set
   * @private
   */
  trySetSessionStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('Could not set session storage value', err);
    }
  }

  /**
   * Try to get a session storage item
   *
   * @param {string} key Key of item to get
   * @returns {string} item found, or null
   * @private
   */
  tryGetSessionStorage(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('Could not get session storage value', err);
      return null;
    }
  }

  /**
   * Whether or not we recognize this browser. If we do not recognize it,
   * we should not make a decision on whether or not to show this banner.
   * @param {string} browser that is being recognized
   * @returns {string} name of browser that is recognized, otherwise ''
   * @private
   */
  recognizedBrowser(browser) {
    const {
      supportMatrix
    } = this.props;
    const matched = Object.keys(supportMatrix).filter(b => browser.match(b));
    return matched.length > 0 ? matched[0] : '';
  }

  /**
   * Whether the whitelist provided contains the current useragent
   * @returns {boolean} true if the useragent whitelist contains the current browser
   * @private
   */
  get userAgentIsWhitelisted() {
    const {
      whitelistedUserAgents
    } = this.props;
    if (typeof navigator === 'object' && navigator.userAgent && whitelistedUserAgents) {
      return whitelistedUserAgents.some(ua => !!navigator.userAgent.match(ua));
    }
    return false;
  }

  /**
   * Whether the blacklist provided contains the browser in question
   * @param {string} browserName name of the browser that is being tested
   * @param {number} browserVersion version of the browser to check
   * @returns {boolean} true if the blacklist contains the browser and version specified
   * @private
   */
  browserIsBlacklisted(browserName, browserVersion) {
    const {
      blacklistedBrowsers
    } = this.props;
    return blacklistedBrowsers.some(_ref => {
      let {
        browser,
        version
      } = _ref;
      return browser === browserName && version === browserVersion;
    });
  }

  /**
   * Whether the version is at or below the supported matrix threshold
   * @param {string} browserName name of the browser that is being tested
   * @param {number} browserVersion version of the browser to check
   * @returns {boolean} true if the browser is at or below the threshold
   * @private
   */
  isUnsupportedBrowser(browserName, browserVersion) {
    const {
      supportMatrix
    } = this.props;
    let unsupportedBrowser = false;
    if (supportMatrix && browserName) {
      const newestWithBanner = supportMatrix[browserName][0];
      if (newestWithBanner != null) {
        unsupportedBrowser = browserVersion > parseFloat(newestWithBanner);
      } else {
        unsupportedBrowser = true;
      }
    }
    return unsupportedBrowser;
  }

  /**
   * Determines if the banner should NOT be rendered
   * @returns {boolean} true if the banner should NOT be shown
   * @private
   */
  // eslint-disable-next-line max-statements, complexity
  shouldNotShowbanner() {
    if (this.userAgentIsWhitelisted) {
      return true;
    }
    const {
      name,
      version,
      dismissed
    } = this.state;
    const {
      supportMatrix,
      disableDeprecationBanner
    } = this.props;
    if (disableDeprecationBanner || dismissed || !supportMatrix || this.tryGetSessionStorage('_dismissedBDF') === 'true') {
      return true;
    }
    const browser = this.recognizedBrowser(name);
    if (!browser || typeof version === 'undefined') {
      return true;
    }
    if (this.browserIsBlacklisted(browser, parseFloat(version))) {
      return false;
    }
    return this.isUnsupportedBrowser(browser, parseFloat(version));
  }

  /**
   * Given that the current browser is supported, render the docs
   * @returns {React.ReactElement[]} 3 <span> tags that contain recommendations to download
   * Firefox, Chrome, or (Safari/Edge) depending on their OS
   * @private
   */
  renderBrowsers() {
    const {
      mac,
      name
    } = this.state;
    const {
      urls: {
        cdn
      }
    } = this.props;
    const filtered = _enums.browsers.filter(b => b !== (mac ? 'Edge' : 'Safari')).sort(a => a !== name ? 1 : 0);
    const get = 'Shared:BrowserDeprecationBanner:GetBrowser';
    const update = 'Shared:BrowserDeprecationBanner:UpdateBrowser';
    return filtered.map(browser => /*#__PURE__*/_react.default.createElement("a", {
      href: _enums.hrefs[browser],
      className: "browser-link",
      key: `name-${browser}`
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: browser,
      src: `${cdn.href}wrhs/browser-deprecation-warning/${browser}.png`,
      className: `browser-icon ${browser.toLowerCase()}`
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "browser-text"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: browser === name ? update : get,
      values: {
        browser
      }
    }))));
  }
  render() {
    if (this.shouldNotShowbanner()) {
      return null;
    }
    typeof document !== 'undefined' && document.documentElement.classList.add('browser-deprecation-banner-shown');
    const _expDataLayer = window._expDataLayer = window._expDataLayer || [];
    _expDataLayer.push({
      schema: 'add_event',
      version: 'v2',
      data: {
        eid: 'uxp.hyd.browser-deprecation-banner.banner.impression',
        type: 'impression',
        custom_properties: {
          userAgent: _objectSpread({}, this.userAgent)
        }
      }
    });
    return /*#__PURE__*/_react.default.createElement("header", {
      role: "banner"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "browser-deprecation-banner"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.dismiss,
      className: "banner-close"
    }, /*#__PURE__*/_react.default.createElement(_x.default, null)), /*#__PURE__*/_react.default.createElement("p", {
      className: "browsers-message"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "browsers-alert",
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement(_alert.default, null)), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:BrowserDeprecationBanner:NewestBrowsers"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "browsers-list"
    }, this.renderBrowsers())));
  }
}

/**
 * Allowed browser deprecation values.
 *
 * @enum {Object}
 * @api public
 */
exports.default = BrowserDeprecationBanner;
BrowserDeprecationBanner.propTypes = {
  supportMatrix: _propTypes.default.object.isRequired,
  whitelistedUserAgents: _propTypes.default.arrayOf(_propTypes.default.string),
  disableDeprecationBanner: _propTypes.default.bool,
  urls: _propTypes.default.shape({
    cdn: _propTypes.default.object
  }).isRequired,
  blacklistedBrowsers: _propTypes.default.arrayOf(_propTypes.default.shape({
    browser: _propTypes.default.string,
    version: _propTypes.default.number
  }))
};
BrowserDeprecationBanner.defaultProps = {
  disableDeprecationBanner: false,
  blacklistedBrowsers: [],
  whitelistedUserAgents: []
};